/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-12-12 14:26:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field } from 'redux-form';
import { RenderTextFieldPrefix } from 'src/components/views/merchandising-v2/rule/conditions/render-text-field-prefix.jsx';
import { DeleteMinor } from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';
import { isRequired, hasTag, isExceedLength } from 'src/helpers/form-validation-helper';
const isExceedLengthValue = isExceedLength(150);

type Props = {
  field: Object
};

type ComposedProps = Props & WithI18nProps;

class RenderQueryField extends Component<ComposedProps> {
  isRequiredValue = isRequired(
    this.props.i18n.translate('AdminHTML.MerchandisingV2.Helper.validateBlankValue')
  );

  render() {
    const rowConditions = this.buildRows();
    return <>{rowConditions.map(row => row)}</>;
  }

  // Render rows for data table
  buildRows = () => {
    const {
      fields,
      formValues,
      merchandisingRules,
      i18n,
      checkDuplicateTerm,
      duplicateTerm,
      isAppliedSingularAndPlurals
    } = this.props;
    const { queries = [] } = formValues;
    const rows = fields.map((condition, index) => {
      // Get product attribute

      return (
        <div className="render-queries-field" key={index}>
          <div className="border-connect-input"></div>
          <Field
            name={`queries[${index}]`}
            merchandisingRules={merchandisingRules}
            formValues={formValues}
            checkDuplicateTerm={checkDuplicateTerm}
            duplicateTerm={duplicateTerm}
            isAppliedSingularAndPlurals={isAppliedSingularAndPlurals}
            component={RenderTextFieldPrefix}
            queryIndex={index}
            ruleId={this.props.ruleId}
            textError={i18n.translate(
              'AdminHTML.MerchandisingV2.Helper.validateConditionQuery_Existed'
            )}
            singularError={i18n.translate(
              'AdminHTML.MerchandisingV2.Helper.validateSingularQuery_Existed'
            )}
            prefix={i18n.translate(`AdminHTML.MerchandisingV2.Conductor.${this.props.conductor}`)}
            placeholder={i18n.translate('AdminHTML.MerchandisingV2.Rule.card1_Field3_Placeholder')}
            label=' '
            validate={[this.isRequiredValue, hasTag, isExceedLengthValue]}
          />
          {queries.length > 1 && (
            <div className="Condition-Modal-Icon-delete" onClick={() => fields.remove(index)}>
              <Icon source={DeleteMinor} color="base" />
            </div>
          )}
        </div>
      );
    });

    return rows;
  };
}

export default withI18n()(RenderQueryField);
